<script>
  const data = [
    {
      text: "Yes!",
      image: "images/yes.jpg",
    },
    {
      text: "No..",
      image: "images/no.jpg",
    },
    {
      text: "Too complicated. Come back later.",
      image: "images/confused.jpg",
    },
  ];
  // Change At Some Point
  let activeAnswer = data[Math.floor(Math.random() * data.length)];
</script>

<section>
  <div>
    <div class="image">
      <img class="img" src={activeAnswer.image} alt="johns answer jonas a" />
    </div>
  </div>
  <p class="text">
    John says:
    <b>
      {activeAnswer.text}
    </b>
  </p>
  <div class="twitter-div">
    <div>
      <p class="john-text">Remember that John knows everything</p>
    </div>
  </div>
  <div class="twitter-container">
    <a href="https://twitter.com/thejonasme" target="_blank">
      <p class="twitter">@thejonasme</p>
    </a>
  </div>
</section>

<style>
  .image {
    margin: 0 auto;
    width: 50%;
    margin-top: 4rem;
    opacity: 1;
    z-index: 2000;
    animation: 3s ease-out 0s 1 spin;
    background-color: #fff;
    background: #333;
    padding: 30px;
  }

  .twitter-container {
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .john-text {
    font-size: 12px;
  }

  .img {
    width: 100%;
    height: auto;
  }

  .twitter {
    font-size: 12px;
    margin-right: 20px;
    cursor: pointer;
    color: cornflowerblue;
    text-align: center;
  }

  .twitter-div {
    display: flex;
    justify-content: center;
  }

  .text {
    text-align: center;
    font-size: 2rem;
    animation: 3s ease-out 0s 1 fadeIn;
  }

  @media only screen and (max-width: 600px) {
    .image {
      width: 90%;
      padding: 10px;
    }

    .text {
      font-size: 1rem;
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes fadeIn {
    0% {
      font-size: 0px;
    }
    100% {
    }
  }
</style>
